export default __webpack_public_path__ + "static/media/memberFileIcon.cb01445f.svg";